import React from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../components/Topbar/Topbar";
import ReportFlow from "../../components/ReportFlow/ReportFlow";
import { logActivity } from "../../utils/activity";

export default function EndGame() {
    const navigate = useNavigate();
    const userEmail = localStorage.getItem("userEmail") || "";

    function handleLogout() {
        logActivity("logout");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("userEmail");
        navigate("/");
    }

    return (
        <>
            <Topbar
                userEmail={userEmail}
                onLogout={handleLogout}
            />
            <div className="endgame-content">
                <ReportFlow />
            </div>
        </>
    );
}
